import socialActionTracking from 'common/tracking/socialActionTracking';

export const trackAddCollectionEntities = () =>
  socialActionTracking('collection', 'add');

export const trackRemoveCollectionEntities = () =>
  socialActionTracking('collection', 'delete');
